/* eslint-disable import/no-anonymous-default-export */
export default (partners = [], action) => {
    switch (action.type) {
        case 'DELETE_PARTNER':
            return partners.filter((partner) => partner._id !== action.payload );
        case 'UPDATE_PARTNER':
            return partners.map((partner) => partner._id === action.payload._id ? action.payload : partner );
        case 'FETCH_ALL_PARTNER':
            return action.payload;
        case 'CREATE_PARTNER':
            return [...partners, action.payload];
        default:
            return partners;
    }
}